module.exports = __webpack_public_path__ + "img/retail-2.ff2fdcfb.png";